import { render } from "./TypeWriter.vue?vue&type=template&id=0ad7fbb2&scoped=true"
import script from "./TypeWriter.vue?vue&type=script&lang=ts"
export * from "./TypeWriter.vue?vue&type=script&lang=ts"

import "./TypeWriter.vue?vue&type=style&index=0&id=0ad7fbb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ad7fbb2"

export default script